import * as lock from "../operations/lock_cell";

export function lockCell(row, column, state, page){
	lock.lockCell(this, row, column, state, false, page);
}

export function isCellLocked(row, column, page){
	return lock.isCellLocked(this, row, column, page);
}